var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 28 28",
    fill: "none",
    stroke: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1802_36265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-20.1543 26.7285L15.0813 51.4007",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20.1543 26.7285L15.0813 51.4007",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-18.4336 24.2715L16.802 48.9437",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-18.4336 24.2715L16.802 48.9437",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16.7129 21.8145L18.5227 46.4867",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16.7129 21.8145L18.5227 46.4867",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-14.9922 19.3574L20.2434 44.0296",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-14.9922 19.3574L20.2434 44.0296",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13.2715 16.8984L21.9641 41.5707",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13.2715 16.8984L21.9641 41.5707",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.5508 14.4414L23.6848 39.1136",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.5508 14.4414L23.6848 39.1136",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.83008 11.9844L25.4055 36.6566",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.83008 11.9844L25.4055 36.6566",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.10938 9.52734L27.1262 34.1996",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.10938 9.52734L27.1262 34.1996",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.38867 7.07031L28.8469 31.7425",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.38867 7.07031L28.8469 31.7425",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.66797 4.61133L30.5676 29.2836",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.66797 4.61133L30.5676 29.2836",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.94727 2.1543L32.2883 26.8265",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.94727 2.1543L32.2883 26.8265",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.22656 -0.302734L34.009 24.3695",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.22656 -0.302734L34.009 24.3695",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.494141 -2.75977L35.7297 21.9125",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.494141 -2.75977L35.7297 21.9125",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.21484 -5.2168L37.4504 19.4554",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.21484 -5.2168L37.4504 19.4554",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.93555 -7.67578L39.1711 16.9964",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.93555 -7.67578L39.1711 16.9964",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.65625 -10.1328L40.8918 14.5394",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.65625 -10.1328L40.8918 14.5394",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.37695 -12.5898L42.6125 12.0824",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.37695 -12.5898L42.6125 12.0824",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.09766 -15.0469L44.3332 9.62535",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.09766 -15.0469L44.3332 9.62535",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8184 -17.5059L46.0539 7.16636",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8184 -17.5059L46.0539 7.16636",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5391 -19.9629L47.7746 4.70933",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5391 -19.9629L47.7746 4.70933",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2598 -22.4199L49.4954 2.2523",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2598 -22.4199L49.4954 2.2523",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9805 -24.877L51.2161 -0.204731",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9805 -24.877L51.2161 -0.204731",
    strokeWidth: 0.882353,
    strokeDasharray: "0.66 2.21"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1802_36265"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 23C0 25.7614 2.23858 28 5 28H28V0.108727H5C2.23858 0.108727 0 2.3473 0 5.10873V23Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash);
export default __webpack_public_path__ + "static/media/dash.054dcffdc6f77cc1d164540e6009e160.svg";
export { ForwardRef as ReactComponent };